/**
 * Хранилище access-токена.
 *
 * §4.2 запрещает держать bearer-токены в localStorage: любой XSS немедленно
 * получает доступ к сессии. Токен живёт только в памяти модуля и умирает
 * вместе с вкладкой. Refresh-токен браузер хранит сам в HttpOnly-cookie,
 * JavaScript его не видит и видеть не должен.
 *
 * Модуль, а не Redux: токен нужен WS-клиенту, который живёт вне React и
 * не должен зависеть от готовности store.
 */

let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function clearAccessToken(): void {
  accessToken = null;
}
